
import request from "@/util/request";

export const Login = (data) => {
    return request({
        url:'sys/login',
        method:'post',
        data
    })
  };
  export const RandomImage = (c_a, _t) => {
    return request({
        url:`sys/randomImage/${c_a}/?_t=${_t}`,
        method:'get',
       
    })
  };
//发送短信
  export const SmsCode = (data) => {
    return request({
        url:'sms/send',
        method:'post',
        data
    })
  };
  //短信登陆
  export const SmsLogin = (data) => {
    return request({
        url:'user/mobilelogin',
        method:'post',
        data
    })
  }; 
  //作者信息
  export const AuthorInfo = (params) => {
    return request({
        url:'pc/author',
        method:'get',
        params, 
       
    })
    };
    //编辑作者信息
    export const EditAuthorInfo = (data) => {
        return request({
            url:'pc/author',
            method:'post',
            data
        })
    };
    //新增音乐,编辑音乐
    export const UploadMusic = (data) => {
        return request({
            url:'pc/music', 
            method:'post',
            data,
        })
     };
     //上传专辑
     export const UploadAlbums = (data) => {
      return request({
          url:'pc/albums', 
          method:'post',
          data,
      })
   };
   //音乐列表
   export const MusicList = (params) => {
    return request({
        url:`pc/music?album_id=${params.id}`,
        method:'get', 
    })
   };
   //专辑列表
   export const AlbumList = (params) => {
    return request({
        url:'pc/albums',
        method:'get',
        params
    })
   };
   //专辑详情
   export const AlbumDetail = (params) => {
    return request({
        url:`pc/albums?id=${params.id}`,
        method:'get',   
    })
   };
   //删除音乐
   export const DeleteMusic = (data) => {
    return request({
        url:'pc/music_del',
        method:'post',
        data,
    })
   };
   //协议
   export const Protocol = (params) => {
    return request({
        url:'configs/login',
        method:'get',
        params
    })
   };
   //合同
   export const Contract = (params) => {
    return request({
        url:'configs/pc',
        method:'get',
        params
    })
   };





